import React from "react";
import styled, { useTheme } from "styled-components/native";
import { VDBText, Container, Spacer } from "@components/atoms";
import { Linking, Pressable, TouchableOpacity } from "react-native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTranslation } from "react-i18next";
import { DownloadVDBProps } from "@scenes/onboarding/utils";
import { useTypographyStore } from "@redux/slices/typographySlice";

const DownloadVDB = ({
  loginCustomization,
  downloadAppText,
}: DownloadVDBProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const typography = useTypographyStore();
  const ContainerComponent = theme.isDesktop ? ContainerWeb : Container;

  const handleAppStoreClick = () => {
    if (theme.isDesktop) {
      Linking.openURL(loginCustomization?.iosStoreUrl ?? "").then();
    }
  };

  const handlePlayStoreClick = () => {
    if (theme.isDesktop) {
      Linking.openURL(loginCustomization?.androidStoreUrl ?? "").then();
    }
  };

  return (
    <>
      <ContainerComponent>
        <VDBText
          color={loginCustomization?.downloadAppTextColour ?? theme["core-06"]}
          type={typography["Body-R"]}
          textAlign="center"
        >
          {downloadAppText ?? t("login.downloadApp.text")}
        </VDBText>
        <Spacer size={SpaceType.ExtraSmall} />
      </ContainerComponent>
      <Pressable
        onPress={() => {
          Linking.openURL("https://vdbapp.com/pricing/marketplace/");
        }}
      >
        <VDBText
          color={theme["link-static"]}
          type={typography["Body-M"]}
          textAlign="center"
        >
          {t(
            "login.downloadApp.explore.text",
            "Explore available subscription plans and special discounts"
          )}
        </VDBText>
      </Pressable>
      <ContainerComponent>
        <IconContainer>
          {loginCustomization?.iosStoreUrl && (
            <AppstoreIcon>
              <TouchableOpacity onPress={handleAppStoreClick}>
                <Logo
                  source={require("../../../../assets/StoreImages/AppStoreIcon.png")}
                  resizeMode="cover"
                />
              </TouchableOpacity>
            </AppstoreIcon>
          )}
          {loginCustomization?.iosStoreUrl &&
            loginCustomization?.androidStoreUrl && (
              <Spacer size={SpaceType.Big} />
            )}
          {loginCustomization?.androidStoreUrl && (
            <PlaystoreIcon>
              <TouchableOpacity onPress={handlePlayStoreClick}>
                <Logo
                  source={require("../../../../assets/StoreImages/PlayStoreIcon.png")}
                  resizeMode="cover"
                />
              </TouchableOpacity>
            </PlaystoreIcon>
          )}
        </IconContainer>
      </ContainerComponent>
    </>
  );
};

const IconContainer = styled.View`
  flex-direction: row;
  width: 100%;
  justify-content: center;
`;

const AppstoreIcon = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;

const PlaystoreIcon = styled.View`
  width: 50%;
  flex: 1;
  justify-content: flex-start;
`;

const Logo = styled.Image`
  height: 40px;
  width: 136px;
`;

const ContainerWeb = styled.View`
  width: 100%;
  padding: 0 ${SpaceType.ExtraLarge}px;
`;

export default DownloadVDB;
